import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header border-0 pt-5" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h3", { class: "card-title align-items-start flex-column" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "card-label fw-bolder fs-3 mb-1" }, "Daftar Pengguna")
], -1)
const _hoisted_4 = { class: "d-flex align-items-center position-relative my-1 ms-auto me-3" }
const _hoisted_5 = { class: "svg-icon svg-icon-1 position-absolute ms-6" }
const _hoisted_6 = { class: "card-toolbar" }
const _hoisted_7 = { class: "svg-icon svg-icon-2" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" User Baru ")
const _hoisted_9 = { class: "card-body py-3" }
const _hoisted_10 = { class: "d-flex align-items-center" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-50px me-5" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "media/avatars/blank.png",
    class: "",
    alt: ""
  })
], -1)
const _hoisted_12 = { class: "d-flex justify-content-start flex-column" }
const _hoisted_13 = {
  href: "#",
  class: "text-dark fw-bolder text-hover-primary mb-1 fs-6"
}
const _hoisted_14 = {
  key: 0,
  class: "text-muted fw-bold text-muted d-block fs-7"
}
const _hoisted_15 = {
  key: 1,
  class: "text-muted fw-bold text-muted d-block fs-7"
}
const _hoisted_16 = {
  key: 2,
  class: "text-muted fw-bold text-muted d-block fs-7"
}
const _hoisted_17 = {
  href: "#",
  class: "text-dark fw-bolder text-hover-primary d-block mb-1 fs-6"
}
const _hoisted_18 = {
  key: 0,
  class: "badge badge-light-danger fs-7 fw-bold"
}
const _hoisted_19 = {
  key: 1,
  class: "badge badge-light-success fs-7 fw-bold"
}
const _hoisted_20 = ["onClick"]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-lock text-info" })
], -1)
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = ["onClick"]
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pen text-primary" })
], -1)
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = ["onClick"]
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash text-danger" })
], -1)
const _hoisted_28 = [
  _hoisted_27
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Datatable = _resolveComponent("Datatable")!
  const _component_ModalEdit = _resolveComponent("ModalEdit")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, [
            _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen021.svg" })
          ]),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
            onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.fetchData())),
            class: "form-control form-control-solid w-250px ps-15",
            placeholder: "Cari Pengguna"
          }, null, 544), [
            [_vModelText, _ctx.search]
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_router_link, {
            to: "/users/add",
            class: "btn btn-primary"
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_7, [
                _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr075.svg" })
              ]),
              _hoisted_8
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_Datatable, {
          "table-data": _ctx.tableData,
          "table-header": _ctx.tableHeader,
          "enable-items-per-page-dropdown": true,
          key: _ctx.tableKey,
          loading: _ctx.is_loading
        }, {
          "cell-full_name": _withCtx(({ row: user }) => [
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("a", _hoisted_13, _toDisplayString(user.full_name), 1),
                (user.role == 1)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_14, "Administrator"))
                  : (user.role == 2)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_15, "Operator"))
                    : (user.role == 88)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_16, "Super Admin"))
                      : _createCommentVNode("", true)
              ])
            ])
          ]),
          "cell-username": _withCtx(({ row: user }) => [
            _createTextVNode(_toDisplayString(user.username), 1)
          ]),
          "cell-email": _withCtx(({ row: user }) => [
            _createElementVNode("a", _hoisted_17, _toDisplayString(user.email), 1)
          ]),
          "cell-disabled": _withCtx(({ row: user }) => [
            (user.disabled)
              ? (_openBlock(), _createElementBlock("span", _hoisted_18, "Non Aktif"))
              : (_openBlock(), _createElementBlock("span", _hoisted_19, "Aktif"))
          ]),
          "cell-actions": _withCtx(({ row: user }) => [
            _createElementVNode("button", {
              class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1",
              onClick: ($event: any) => (_ctx.resetPassword(user._id))
            }, _hoisted_22, 8, _hoisted_20),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1",
              "data-bs-toggle": "modal",
              "data-bs-target": "#kt_modal_edit_user",
              onClick: ($event: any) => (_ctx.showModalEdit(user))
            }, _hoisted_25, 8, _hoisted_23),
            _createElementVNode("button", {
              class: "btn btn-icon btn-bg-light btn-active-color-danger btn-sm",
              onClick: ($event: any) => (_ctx.deleteUser(user._id))
            }, _hoisted_28, 8, _hoisted_26)
          ]),
          _: 1
        }, 8, ["table-data", "table-header", "loading"])
      ])
    ]),
    _createVNode(_component_ModalEdit, {
      ref: "modalEdit",
      onFetchData: _cache[2] || (_cache[2] = ($event: any) => (_ctx.fetchData()))
    }, null, 512)
  ], 64))
}